export default __webpack_public_path__ + "static/media/alialam.de1c5eb9.jpg";